import ccCookieConsent from './components/consent.js';
import MainMenu from './components/mainmenu.js';
import NavScroller from './components/navscroller.js';
import Lightbox from './components/glightbox.js';
import CutoffText from './components/cutofftext.js';
import { swiperStage } from './components/swiper.js';
// Import Store
import { constants, instances } from './store/index.js';

// add stuff
document.documentElement.classList.add('js');

// create instances
instances.ccCookieConsent = new ccCookieConsent();
instances.ccCookieConsent.init();

instances.mainmenu = new MainMenu();
instances.mainmenu.init();

instances.navscroller = new NavScroller();
instances.navscroller.init();

instances.lightbox = new Lightbox();
instances.lightbox.init(); 

instances.cutofftext = new CutoffText();
instances.cutofftext.init(); 

// run functions 
// swipers
swiperStage();
